import { Slot } from "@radix-ui/react-slot";
import type * as React from "react";

type ButtonVariant =
	| "default"
	| "destructive"
	| "outline"
	| "secondary"
	| "ghost"
	| "link";

type ButtonSize = "default" | "sm" | "lg" | "icon" | "icon-sm" | "icon-lg";

function Button({
	className,
	variant = "default",
	size = "default",
	asChild = false,
	...props
}: React.ComponentProps<"button"> & {
	variant?: ButtonVariant;
	size?: ButtonSize;
	asChild?: boolean;
}) {
	const Comp = asChild ? Slot : "button";

	return (
		<Comp
			data-variant={variant}
			data-size={size}
			className={className}
			{...props}
			data-slot="button"
		/>
	);
}

export { Button };
export type { ButtonVariant, ButtonSize };
